export default "__VITE_ASSET__BDuV4S7h__"